export default __webpack_public_path__ + "static/media/sub-category-musicAndArts-recordingStudio.9b609ea8.jpg";